import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, CardTitle } from '../../../../ui-kit';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { DateFromTo, TopTableComponent } from '../../../../generated/graphql';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import { routePaths } from '../../../../routePaths';
import LinkComponent from '../LinkComponent';
import TopTableCardView from './TopTableCardView';

const TopTableCard = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();
    const { dateTimeService } = useDateTimeService();
    const history = useHistory();

    let searchParams: string | undefined;
    if (dateFromTo) {
        const from = dateTimeService.getDateTimeFromJsDate(dateFromTo.from).toISODate();
        const to = dateTimeService.getDateTimeFromJsDate(dateFromTo.to).toISODate();
        if (from && to) {
            searchParams = new URLSearchParams({
                from,
                to,
            }).toString();
        }
    }

    const referrer = `${history.location.pathname}${history.location.search}`;

    return (
        <TopTableComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={351} />}
        >
            {({ data: { topTable } }) => (
                <Card fullHeight>
                    <CardContent padding={3}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box display='flex' alignItems='center'>
                                    <CardTitle>{t('Top table')}</CardTitle>
                                    <LinkComponent search={searchParams} pathname={routePaths.reportsTables} referrer={referrer} />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <TopTableCardView {...topTable} />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )}
        </TopTableComponent>
    );
};
export default TopTableCard;